var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.64917,
    cy: 6.06519,
    r: 3.98169,
    stroke: "#718096",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33351 15.5846C3.33244 15.3047 3.39504 15.0282 3.51658 14.7761C3.89796 14.0133 4.97348 13.609 5.86593 13.426C6.50956 13.2886 7.16208 13.1969 7.81864 13.1514C9.0342 13.0446 10.2568 13.0446 11.4723 13.1514C12.1288 13.1974 12.7813 13.2891 13.425 13.426C14.3175 13.609 15.393 13.9752 15.7744 14.7761C16.0188 15.2901 16.0188 15.8868 15.7744 16.4008C15.393 17.2017 14.3175 17.5678 13.425 17.7433C12.7822 17.8863 12.1294 17.9807 11.4723 18.0255C10.483 18.1094 9.48898 18.1247 8.49751 18.0713C8.26867 18.0713 8.04747 18.0713 7.81864 18.0255C7.16402 17.9812 6.51376 17.8869 5.87356 17.7433C4.97348 17.5678 3.90559 17.2017 3.51658 16.4008C3.39566 16.1457 3.33312 15.8669 3.33351 15.5846Z",
    stroke: "#718096",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5cc8f5c446a53dd581c87a1bd16871e8.svg";
export { ForwardRef as ReactComponent };